import {defineMessages} from 'react-intl'

export const PRICE_FILTER_MESSAGES = defineMessages({
  nightlyPrice: {
    id: 'nightlyPrice',
    defaultMessage: 'Nightly price'
  },
  totalPrice: {
    id: 'totalPrice',
    defaultMessage: 'Total price'
  },
  nightlyMultipleRoomsWithTaxAndFees: {
    id: 'priceRange.nightlyMultipleRoomsWithTaxAndFees',
    defaultMessage: 'For all rooms, including taxes and fees'
  },
  totalSingleRoom: {
    id: 'priceRange.totalSingleRoom',
    defaultMessage: 'Including all nights, taxes and fees'
  },
  totalMultipleRooms: {
    id: 'priceRange.totalMultipleRooms',
    defaultMessage: 'For all rooms, including all nights, taxes and fees'
  },
  nightlyExclTaxAndFees: {
    id: 'priceRange.nightlyExclTaxAndFees',
    defaultMessage: 'Excluding taxes and fees'
  },
  nightlyMultipleRoomsExclTaxAndFees: {
    id: 'priceRange.nightlyMultipleRoomsExclTaxAndFees',
    defaultMessage: 'For all rooms, excluding taxes and fees'
  },
  nightlyWithTaxesExclAndFeesIncl: {
    id: 'priceRange.nightlyWithTaxesExclAndFeesIncl',
    defaultMessage: 'Excluding taxes, including fees'
  },
  nightlyMultipleRoomsWithTaxesExclAndFeesIncl: {
    id: 'priceRange.nightlyMultipleRoomsWithTaxesExclAndFeesIncl',
    defaultMessage: 'For all rooms, excluding taxes, including fees'
  },
  includingTaxesLong: {
    id: 'includingTaxesLong',
    defaultMessage: 'including taxes and fees'
  }
})
